import moment from "moment";
import { AmlStatusEnum } from "../../model";

export type AssociatedPartyRoles = {
  code: string;
  desc: string;
};

export type AssociatedPartiesItem = {
  roles?: AssociatedPartyRoles[];
  role: string;
  roleDesc: string;
  roleSeq: number;
  investorId: string;
  title: string;
  firstName: string;
  middleName: string;
  surname: string;
  entityType: string;
  entityName: string;
  amlStatus: AmlStatusEnum;
  idAndV: string;
  pepStatus: string;
  sanctionsStatus: string;
  riskRatingStatus: string;
  createdDate: string;
  createdTime: string;
};

export function associatedPartiesRequestTransformer(
  row: any
): AssociatedPartiesItem {
  return {
    role: row.roleType,
    roleDesc: row.roleTypeDesc,
    // sqe is an API typo
    roleSeq: Number(row.roleSqe),
    investorId: row.personId,
    title: row.title,
    firstName: row.firstName,
    middleName: row.middleName,
    surname: row.surname,
    entityType: row.entityType,
    entityName: row.entityName,
    amlStatus: row.amlStatus,
    idAndV: row.idAndV,
    pepStatus: row.pepStatus,
    sanctionsStatus: row.sanctionsStatus,
    riskRatingStatus: row.riskStatus,
    createdDate: row.updatedDate || row.createdDate,
    createdTime: row.updatedTime || row.createdTime,
  };
}

export type AssociatedPartiesHistoryItem = {
  role: string;
  roleDesc: string;
  investorId: string;
  title: string;
  firstName: string;
  middleName: string;
  surname: string;
  entityType: string;
  entityName: string;
  updatedBy: string;
  removed: boolean;
  timestamp: number | null;
};

export function associatedPartiesHistoryRequestTransformer(
  row: any
): AssociatedPartiesHistoryItem {
  const data = {
    role: row.roleType,
    roleDesc: row.roleTypeDesc,
    investorId: row.personId,
    title: row.title,
    firstName: row.firstName,
    middleName: row.middleName,
    surname: row.surname,
    entityType: row.entityType,
    entityName: row.entityName,
    updatedBy: row.updatedByUser,
    removed: Boolean(row.removedTime) || Boolean(row.removedDate),
    timestamp: null,
  };

  if (data.removed) {
    data.timestamp = toTimestamp(row.removedDate, row.removedTime);
  } else if (row.updatedDate) {
    data.timestamp = toTimestamp(row.updatedDate, row.updatedTime);
  } else {
    data.timestamp = toTimestamp(row.createdDate, row.createdTime);
  }
  return data;
}

function toTimestamp(dateStr: number, timeStr: number): any {
  if (dateStr === 0 || timeStr === 0) {
    return null;
  }
  const paddingTimeStr = `0${timeStr}`.slice(-6);
  const fullStr = `${dateStr} ${paddingTimeStr}`;
  return moment(fullStr, "YYYYMMDD HHmmss").valueOf();
}
